export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center pt-16 overflow-hidden bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"
    >
      <div className="section-container relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium mb-4 md:mb-5">
              <i className="ri-fire-line"></i>
              <span>全网最快娱乐爆料平台</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 leading-tight mb-3 md:mb-4">
              91吃瓜爆料 — 最强吃瓜群众社区
            </h1>

            <p className="text-base md:text-lg text-foreground-600 mb-4 md:mb-5 font-medium">
              汇聚百万吃瓜群众，围观热门事件，每日吃瓜讨论
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 md:mb-7 max-w-xl mx-auto lg:mx-0">
              91吃瓜爆料致力于打造国内最活跃的在线吃瓜互动社区，汇聚91i吃瓜网核心圈层用户，每日更新最新娱乐圈爆料、明星动态、综艺内幕等内容。无论你是资深吃瓜群众还是刚入圈的萌新，这里都有你想要的吃瓜福利和讨论空间，一起围观热门事件、畅聊吃瓜话题。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-7">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-user-smile-line text-primary-500 text-lg"></i>
                <span><strong className="text-foreground-900">180万+</strong> 日活用户</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-article-line text-primary-500 text-lg"></i>
                <span><strong className="text-foreground-900">500+条</strong> 每日更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-shield-check-line text-primary-500 text-lg"></i>
                <span><strong className="text-foreground-900">匿名保护</strong> 安全投稿</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <i className="ri-flashlight-line"></i>
                立即围观最新爆料
              </a>
              <a
                href="#app"
                onClick={(e) => handleScrollTo(e, '#app')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 hover:bg-background-100 text-foreground-800 font-medium rounded-lg border border-background-300 transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <i className="ri-download-2-line"></i>
                下载吃瓜APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-200/30 rounded-3xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20social%20media%20entertainment%20community%20concept%20art%2C%20vibrant%20warm%20orange%20and%20coral%20abstract%20illustration%2C%20people%20gathering%20and%20chatting%20visual%20metaphor%2C%20energetic%20creative%20design%2C%20playful%20informal%20atmosphere%2C%20flat%20illustration%20style%20with%20depth&width=800&height=700&seq=hero-main-01&orientation=portrait"
                alt="91吃瓜爆料社区互动主视觉"
                className="relative w-full h-auto rounded-2xl object-cover"
                width="800"
                height="700"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}